import { InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useSearchParams } from "@/hooks/useSearchParams";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useGetPaymentAccountsQuery } from "@/features/app/appApiSlice";
import { handleError } from "@/utils/handleError";
import { ISelectPaymentParams } from "@/types/base";
import { IPaymentAccountItem } from "@/features/app/types";
import * as Styled from "./SelectPaymentMerchant.styles";

const PaymentMerchantSelectLabel = "Payment Merchant";

export const SelectPaymentMerchant = () => {
  const [paymentMerchants, setPaymentMerchants] = useState<Array<any>>([]);
  const { data, isFetching, error } = useGetPaymentAccountsQuery();
  const { paymentAccounts: defaultOptions = [] } = data || {};
  const options: Array<any> = useMemo(() => {
    return Array.from(
      new Map(
        defaultOptions.map((item: IPaymentAccountItem) => [
          item.merchantId,
          {
            value: item.merchantId.toString(),
            label: item.merchantName,
            operatorId: item.operatorId.toString(),
          },
        ]),
      ).values(),
    );
  }, [defaultOptions]);

  const { parsedSearchParams, mergeSearchParams } =
    useSearchParams<ISelectPaymentParams>();
  const { merchant, operator } = parsedSearchParams || "";

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error]);

  useEffect(() => {
    if (paymentMerchants?.length && !merchant) {
      mergeSearchParams({
        merchant: paymentMerchants[0].value,
      });
    }
  }, [mergeSearchParams, merchant, paymentMerchants]);

  useEffect(() => {
    if (operator) {
      const filteredOptions =
        options.filter((item) => item.operatorId === operator) || [];
      setPaymentMerchants(filteredOptions);
      const existOption = filteredOptions.find(
        (item) => item.value === merchant,
      );

      if (filteredOptions?.length && !existOption) {
        mergeSearchParams({
          merchant: filteredOptions[0].value,
        });
      }
    }
  }, [merchant, mergeSearchParams, operator, options]);

  const handlePaymentMerchantChange = useCallback(
    (event: SelectChangeEvent) => {
      mergeSearchParams({
        merchant: event?.target.value,
      });
    },
    [mergeSearchParams],
  );

  return (
    <Styled.FormControl disabled={isFetching}>
      <InputLabel>{PaymentMerchantSelectLabel}</InputLabel>
      <Select
        value={merchant || ""}
        label={PaymentMerchantSelectLabel}
        onChange={handlePaymentMerchantChange}
      >
        {paymentMerchants?.map((option: any) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Styled.FormControl>
  );
};
